<template>
  <div>
    <el-form-item prop="buyer-info"></el-form-item>
    <div class="col-12 sector buyer-sector px-3">
      <div class="row">
        <div class="sector__header">{{ t("carts.buyerInfo") }}</div>
        <div class="sector__content">
          <div class="row">
            <div class="col-12 col-md-3">
              <el-form-item :label="t('users.name')" prop="buyer_name">
                <el-input v-model="form.buyer_name" :placeholder="t('carts.required')" size="large" maxlength="50" />
              </el-form-item>
            </div>

            <div class="col-12 col-md-4">
              <el-form-item :label="t('users.phone')" prop="buyer_mobile">
                <el-input v-model="form.buyer_mobile" :placeholder="t('carts.required')" size="large" maxlength="20" />
              </el-form-item>
            </div>

            <div class="col-12 col-md-5">
              <el-form-item :label="t('users.email')" prop="buyer_email">
                <el-input v-model="form.buyer_email" :placeholder="t('carts.optional')" size="large" maxlength="50" />
              </el-form-item>
            </div>
          </div>
        </div>
      </div>
      <p class="text-primary">（為了方便您查詢訂單，訂購人手機號碼與登入會員之號碼需一致）</p>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref, computed } from 'vue'
import { useI18n } from "vue-i18n"
import { useVModel } from '@vueuse/core'

const props = defineProps({
  modelValue: Object,
})
const emit = defineEmits(['update:modelValue'])

const { t, locale } = useI18n()

const form = useVModel(props, 'modelValue', emit)
</script>
